import { getHeaders } from "#src/api/utils";

export const APIGetMyTokens = async (companyId) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    if (!companyId) {
        throw new Error('Invalid data');
    }
    
    const requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow',
    };

    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/token/1.0/all/${companyId}`, requestOptions);
        const responseObject = await response.json();
        const tokens = responseObject.data;

        if (tokens) {
            return tokens;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APICreateToken = async (tokenData) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    if (!tokenData?.companyId || !tokenData?.name) {
        throw new Error('Invalid data');
        }

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(tokenData),
      redirect: 'follow',
    };
  
    try {
      const apiUrl =
        process.env.REACT_APP_MODE === 'PROD'
          ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
          : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
      const response = await fetch(`${apiUrl}/token/1.0/token `, requestOptions);
      const responseObject = await response.json();
      const token = responseObject.data;
  
      if (token) {
        return token;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
}

export const APIUpdateToken = async (token) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    if (!token?.id || !token?.status || !token?.name) {
        throw new Error('Invalid data');
    }

    const requestOptions = {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(token),
        redirect: 'follow',
    };

    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/token/1.0/token/${token.id}`, requestOptions);
        const responseObject = await response.json();
        const updatedToken = responseObject.data;

        if (updatedToken) {
            return updatedToken;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIDeleteToken = async (tokenId) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    if (!tokenId) {
        throw new Error('Invalid data');
    }

    const requestOptions = {
        method: 'DELETE',
        headers: headers,
        redirect: 'follow',
    };

    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/token/1.0/token/${tokenId}`, requestOptions);
        const responseObject = await response.json();
        const deletedToken = responseObject.data;

        if (deletedToken) {
            return deletedToken;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
} 